<template>
    <div id="filterWrapper">
        <zip-filter v-if="!isInMobile"/>
        <featured-filter v-if="!isInMobile"/>

        <div id="filterDisplay" :class="[orientation, $store.getters.isLoggedIn ? 'auth' : '']">
            <search-filter :id="filter.name" v-for="filter in $store.getters.getAvailableFilters" :key="filter.name" :filter="filter"/>
            <div v-if="!isInMobile" id="filterResetFooterButton"   @click="reset()">
                Reset
            </div>
        </div>

       <div id="filterFooter" v-if="isInMobile" :class="[$store.getters.getOrientation]">
            <div id="reset_filters_button" @click="reset()">
                RESET
            </div>
            <div id="viewMobileResultsButton"  v-if="isInMobile" @click="showMobileResults">
                VIEW RESULTS
            </div>
        </div>
    </div>
</template>

<script>
    import SearchFilter from '../components/Filter.vue';
    import ZipFilter from '../components/ZipFilter';
    import FeaturedFilter from '../components/FeaturedFilter.vue';

    export default {
        data() {
            return {

            }
        },
        components: {
            'search-filter': SearchFilter,
            'zip-filter': ZipFilter,
            'featured-filter': FeaturedFilter
        },
        computed: {
            isInMobile() {
                return this.$store.getters.isMobile;
            },
            orientation() {
                return this.$store.getters.getOrientation;
            }
        },
        methods: {
            reset() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('reset', {'event_category': 'filter_selection','event_label': eventLabel});
                this.$store.dispatch('clearAllFilterSelections')
            },
            showMobileResults() {
                this.$store.commit('updateShowMobileVehicleResultsStatus', true);
            }
        }
    }
</script>

<style>
    #filterWrapper {
        width: inherit;
        height: calc(83 * var(--vh));
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em));
    }

    .inmobile #filterWrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: calc(66 * var(--vh));
        font-size: calc(2.1 * var(--vh));
    }

    #filterDisplay {
        display: flex;
        height: calc(60 * var(--vh));
        flex-direction: column;
        justify-content: flex-start;
        border-top: 1px solid #707f99;
        overflow-y: scroll;
    }

    .inmobile #filterDisplay {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
        height: calc(60 * var(--vh));
        border: none;
        overflow: hidden;
        max-height: calc(60 * var(--vh));
        margin: calc(9 * var(--vw)) calc(.5 * var(--vh)) 0 calc(.5 * var(--vh));
        align-items: flex-end
    }

    .inmobile.tabletstyle #filterDisplay {
        align-items: flex-start;
    }

    .inmobile #filterDisplay.auth {
        margin: calc(8 * var(--vw)) calc(.5 * var(--vh)) 0 calc(.5 * var(--vh));
    }

    .inmobile.tabletstyle #filterDisplay.landscape {
        margin: calc(2 * var(--vw)) calc(.5 * var(--vh)) 0 calc(.5 * var(--vh));
        align-items: center;
    }

    #filterResetFooterButton {
        color: white;
        padding: calc(1.2 * var(--vh)) calc(1 * var(--vw));
        text-align: center;
        border-top: 1px solid #2B2A2B;
        border-bottom: 1px solid #545454;
        cursor: pointer;
        font-style: italic;
    }

    #filterResetFooterButton:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
        border-color: var(--mccluskeyGold); /*#AF873F;*/
    }

    #filterFooter {
        height: calc(3 * var(--vh));
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding: calc(1 * var(--vw)) 0;
    }

    .inmobile #filterFooter {
        height: calc(7 * var(--vh));
        justify-content: flex-end;
        align-items: center;
        margin-top: 0;
    }

    #reset_filters_button {
        background-color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*/
        border-radius: calc(var(--vratio) * var(--vh));
        height: calc(3 * var(--vh));
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: lighter;
        color: white;
        border: solid white .75px;
        font-style: italic;
        font-size: .86em;
    }

    .inmobile #reset_filters_button {
        background-color: white;
        color: #2c3e50;
        border-radius: 0;
        width: fit-content;
        height: fit-content;
        font-size: calc(2 * var(--vh));
        font-weight: normal;
        margin: calc(1 * var(--vh));
        font-style: normal;
        font-weight: bold;
    }
    
    #viewMobileResultsButton {
        background-color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*/
        border-radius: 5px;
        width: calc(40 * var(--vw));
        height: calc(3.2 * var(--vh));
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: bold;
        color: white;
        font-size: calc(2.1 * var(--vh));
        margin: 0 calc(2 * var(--vw));
        border: solid white .75px;
    }

    .inmobile.tabletstyle .landscape #viewMobileResultsButton {
        width: calc(20 * var(--vw));
    }

    #reset_filters_button:hover {
        color: black;
        border-color: var(--mccluskeyGold); /*#AF873F;*/
    }

    .inmobile #reset_filters_button:hover {
        color: black;
        border-color: var(--mccluskeyGold); /*#AF873F;*/
    }
</style>